import React, { useState, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { Toast } from "primereact/toast";
import emailjs from "@emailjs/browser";

export default function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const toast = useRef(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e?.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      toast.current.show({
        severity: "warn",
        summary: "Incomplete",
        detail: "Please fill all fields",
        life: 3000,
      });
      return;
    }

    setLoading(true);

    // Replace these with your own EmailJS credentials
 
    const serviceID = "service_d9q7c4f";         // e.g. service_abc123
    const templateID = "template_0wvx3qi";       // e.g. template_xyz789
    const publicKey = "fC6bP2sYWvF1tG9fH";         // e.g. AbC123dEfG456hIjK

    // Template params matching the EmailJS template: {{name}}, {{time}}, {{message}}
    // Email is included in the message body for response convenience
    const templateParams = {
      name: formData.name,
      time: new Date().toLocaleString(),
      message: `From: ${formData.email}\n\n${formData.message}`,
    };

    emailjs
      .send(serviceID, templateID, templateParams, publicKey)
      .then((response) => {
        toast.current.show({
          severity: "success",
          summary: "Message Sent!",
          detail: "Thank you! We’ll get back to you soon.",
          life: 5000,
        });
        setFormData({ name: "", email: "", message: "" });
      })
      .catch((err) => {
        console.error("EmailJS error:", err);
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "Something went wrong. Please try again later.",
          life: 5000,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Toast ref={toast} />

      <div className="flex justify-content-center align-items-center min-h-screen bg-gray-100 p-4">
        <div className="flex flex-wrap w-full max-w-6xl gap-6">
          {/* Contact Form */}
          <div className="w-full md:w-6">
            <Card className="h-full">
              <h2 className="text-2xl font-semibold mb-3 text-center">Contact Us</h2>
              <Divider />

              <form onSubmit={handleSubmit} className="p-fluid">
                <div className="field mb-4">
                  <label htmlFor="name">Name</label>
                  <InputText
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your name"
                    required
                  />
                </div>

                <div className="field mb-4">
                  <label htmlFor="email">Email</label>
                  <InputText
                    id="email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    required
                  />
                </div>

                <div className="field mb-4">
                  <label htmlFor="message">Message</label>
                  <InputTextarea
                    id="message"
                    name="message"
                    rows={5}
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Type your message here..."
                    required
                  />
                </div>

                <Button
                  type="submit"
                  label={loading ? "Sending..." : "Send Message"}
                  icon="pi pi-send"
                  className="w-full"
                  disabled={loading}
                  loading={loading}
                />
              </form>
            </Card>
          </div>

          {/* Contact Info */}
          <div className="w-full md:w-5">
            <Card className="h-full">
              <h2 className="text-2xl font-semibold mb-3 text-center">Get in Touch</h2>
              <Divider />

              <div className="flex align-items-start mb-4">
                <i className="pi pi-map-marker text-blue-500 text-2xl mr-3"></i>
                <div>
                  <h4 className="font-semibold m-0">Address</h4>
                  <p className="m-0 text-600">
                    G - Floor, Swathi Plaza,<br />
                    Shyam Karan Rd, Leelanagar,<br />
                    Ameerpet, Hyderabad,<br />
                    Telangana, 500016.
                  </p>
                </div>
              </div>

              <div className="flex align-items-start mb-4">
                <i className="pi pi-envelope text-green-500 text-2xl mr-3"></i>
                <div>
                  <h4 className="font-semibold m-0">Email</h4>
                  <p className="m-0 text-600">admin@snpfinvisors.com</p>
                </div>
              </div>

              <div className="flex align-items-start">
                <i className="pi pi-phone text-purple-500 text-2xl mr-3"></i>
                <div>
                  <h4 className="font-semibold m-0">Phone</h4>
                  <p className="m-0 text-600">
                    +91-93923 34305<br />
                    +91-93923 58230
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}